import Button from '../../../components/base/Button';

export default function ProgramsSection() {
  const programs = [
    {
      title: 'Strength Training',
      description: 'Build muscle and increase power with our comprehensive strength training program',
      icon: 'ri-boxing-line',
      color: 'from-red-600 to-red-700'
    },
    {
      title: 'Cardio Workouts',
      description: 'Improve endurance and burn calories with state-of-the-art cardio equipment',
      icon: 'ri-heart-pulse-line',
      color: 'from-gray-900 to-black'
    },
    {
      title: 'HIIT Training',
      description: 'High-intensity interval training for maximum calorie burn',
      icon: 'ri-flashlight-line',
      color: 'from-red-700 to-red-800'
    },
    {
      title: 'Zumba & Aerobics',
      description: 'Dance your way to fitness with energetic classes',
      icon: 'ri-music-2-line',
      color: 'from-gray-800 to-gray-900'
    },
    {
      title: 'Personal Training',
      description: 'One-on-one coaching tailored to your specific goals',
      icon: 'ri-user-star-line',
      color: 'from-red-500 to-red-600'
    },
    {
      title: 'Group Classes',
      description: 'Join motivating group sessions including yoga and pilates',
      icon: 'ri-team-line',
      color: 'from-black to-gray-900'
    }
  ];

  return (
    <section id="services" className="py-12 lg:py-24 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-72 h-72 bg-red-600 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-red-700 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-6 lg:mb-16">
          <div className="inline-flex items-center gap-1.5 px-2 py-1 lg:px-4 lg:py-2 bg-red-100 rounded-full mb-2 lg:mb-6">
            <i className="ri-trophy-line text-red-600 text-xs lg:text-base"></i>
            <span className="text-[10px] lg:text-sm font-bold text-red-600 uppercase tracking-wider">Our Programs</span>
          </div>
          <h3 className="text-2xl lg:text-6xl font-black text-gray-900 mb-2 lg:mb-6">
            Programs <span className="text-red-600">For Every Goal</span>
          </h3>
          <p className="text-xs lg:text-xl text-gray-600 max-w-3xl mx-auto">
            From bodybuilding to Zumba, we offer diverse training programs
          </p>
        </div>

        {/* Programs Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-6">
          {programs.map((program, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg lg:rounded-3xl transition-all duration-500 hover:scale-105 hover:shadow-2xl cursor-pointer"
            >
              {/* Background Gradient */}
              <div className={`absolute inset-0 bg-gradient-to-br ${program.color} opacity-90 group-hover:opacity-100 transition-opacity duration-300`}></div>
              
              {/* Pattern Overlay */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0" style={{
                  backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
                  backgroundSize: '20px 20px'
                }}></div>
              </div>

              {/* Content */}
              <div className="relative p-3 lg:p-8 h-full flex flex-col justify-between min-h-[100px] lg:min-h-[280px]">
                {/* Icon */}
                <div className="mb-2 lg:mb-6">
                  <div className="w-8 h-8 lg:w-16 lg:h-16 bg-white/20 backdrop-blur-sm rounded-lg lg:rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                    <i className={`${program.icon} text-xl lg:text-4xl text-white`}></i>
                  </div>
                </div>

                {/* Text */}
                <div>
                  <h4 className="text-xs lg:text-2xl font-black text-white mb-0.5 lg:mb-3 group-hover:translate-x-1 transition-transform duration-300 leading-tight">
                    {program.title}
                  </h4>
                  <p className="text-white/90 text-[9px] lg:text-sm leading-relaxed hidden lg:block">
                    {program.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-6 lg:mt-16">
          <p className="text-gray-600 mb-3 lg:mb-6 text-xs lg:text-lg">
            Not sure which program is right for you?
          </p>
          <Button
            href="#contact"
            variant="primary"
            icon="ri-chat-smile-2-line"
            iconPosition="right"
            className="text-xs lg:text-base px-4 py-2 lg:px-8 lg:py-4"
          >
            Get Free Consultation
          </Button>
        </div>
      </div>
    </section>
  );
}
